// Handy degrees -> radians method:
Number.prototype.toRad=function(){return this.valueOf() * (Math.PI/180)}